import { League, MyTeamLeagues } from '@/entities';
import { LeagueDto, MyTeamLeaguesDto } from '@/infrastructure/network/dto/MyTeamLeaguesDto';

const leagueDtoToLeague = (dto: LeagueDto): League => {
	return {
		uuid: dto.uuid,
		playerCount: dto.playerCount,
		isFavourite: dto.isFavourite,
		logo: dto.logo
			? {
					uuid: dto.logo.uuid,
					url: dto.logo.url
				}
			: { uuid: '', url: '' },
		startDatetime: dto.startDatetime,
		organizationUuid: dto.organizationUuid,
		endDatetime: dto.endDatetime,
		title: dto.title,
		location: dto.location
			? {
					city: dto.location.city,
					stateInfo: dto.location.stateInfo,
					countryInfo: dto.location.countryInfo
				}
			: null,
		isSeasonActive: dto.isSeasonActive,
		slug: dto.slug
	};
};

export const myTeamLeaguesDtoToMyTeamLeagues = (dto: MyTeamLeaguesDto): MyTeamLeagues => {
	return {
		totalRecords: dto.totalRecords,
		teamLeagues: dto.teamLeagues.map(leagueDtoToLeague)
	};
};
